import jsQR from "jsqr";

async function decodeQrFromImageUrl(imageUrl: string) {
    // Tạo Image object
    const img = new Image();
    img.crossOrigin = "Anonymous"; // quan trọng nếu ảnh khác domain

    return new Promise((resolve, reject) => {
        img.onload = () => {
            // Tạo canvas
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext("2d");
            ctx?.drawImage(img, 0, 0);

            // Lấy dữ liệu pixel ảnh
            const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);
            if (!imageData) {
                reject("Failed to get image data");
                return;
            }
            // Dùng jsQR decode
            const code = jsQR(imageData.data, imageData.width, imageData.height);
            if (code) {
                resolve(code.data);
            } else {
                reject("QR code not found");
            }
        };

        img.onerror = () => reject("Failed to load image");
        img.src = imageUrl;
    });
}

export { decodeQrFromImageUrl };
